import { Button, InputAdornment, MenuItem, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import updateItemApi from "../../../api/auth/items/updateItem";
import WushTextField from "../WushTextField";
import useItemStore from "../../../stores/useItemStore";
import createItem from "../../../api/auth/items/createItem";
import useAlertStore from "../../../stores/useAlertStore";
import ItemCategoryName from "../../text/ItemCategoryName";
import useAuthStore from "../../../stores/useAuthStore";
import WushYesNoField from "../WushYesNoField";
import ReactQuill from "react-quill";
import WushFileUploader from "../WushFileUploader";
import uploadFile from "../../../api/auth/items/uploadFile";

export default function ItemForm({ item, afterUpdate, afterCreate, showImage }) {
  const { register, handleSubmit, setValue, formState: { isDirty } } = useForm({
    defaultValues: {
      name: item?.name,
      description: item?.description,
      item_category_id: item?.item_category_id,
    }
  });
  const { updateItem, addItem, itemCategories } = useItemStore();

  const { setAlertMessage } = useAlertStore();

  const { organization } = useAuthStore();

  const onSubmit = (data) => {
    if(item?.id) {
      updateItemApi(item.id, data, (response) => {
        updateItem(response);
        setAlertMessage("Item updated successfully", "success");
        afterUpdate && afterUpdate(response);
      }, (error) => {
        console.log(error);
      });
    } else {
      createItem(data, (response) => {
        addItem(response);
        afterCreate && afterCreate(response);
      }, (error) => {
        console.log(error);
      });
    }
  };

  const uploadImage = (file) =>{
    uploadFile(item.id, file, (response) => {
      setAlertMessage("Image uploaded successfully", "success");
      updateItem(response);
    });
  };

  console.log(item);

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={2}>
          <WushTextField formRegistration={register("name")} label="Name" defaultValue={item?.name} />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("description")} label="Description" defaultValue={item?.description} multiline />
        </Stack>
        {showImage && item.image_url && <Stack mb={1}>
          <img
            style={{
              borderRadius: "5px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
            width="150px"
            src={item.image_url}
            alt="Store Image"
          />
        </Stack>}
        {showImage && <Stack mb={2}>
          <WushFileUploader handleFileUpload={uploadImage} />
        </Stack>}
        <Stack mb={2}>
          <ReactQuill
            theme="snow"
            value={item?.storefront_description}
            onChange={(value) => setValue("storefront_description", value, { shouldDirty: true})}
          />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("stock")} label="Quantity" defaultValue={item?.stock} type="number" />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("item_category_id")} label="Item Group" select defaultValue={item?.item_category_id}>
            {itemCategories.map((itemCategory) => (
              <MenuItem key={itemCategory.id} value={itemCategory.id}>
                <ItemCategoryName  itemCategory={itemCategory} />
              </MenuItem>
            ))}
          </WushTextField>
        </Stack>
        <Stack direction="row" mb={2} gap={1}>
          <WushTextField
            formRegistration={register("state_tax_percent")}
            label="State Tax"
            defaultValue={item?.state_tax_percent || organization.state_tax_percent}
            inputStartAdornment={<InputAdornment position="start">%</InputAdornment>}
            sx={{ maxWidth: "100px" }}
          />
          <WushTextField
            formRegistration={register("local_tax_percent")}
            label="Local Tax"
            defaultValue={item?.local_tax_percent || organization.local_tax_percent}
            inputStartAdornment={<InputAdornment position="start">%</InputAdornment>}
            sx={{ maxWidth: "100px" }}
          />
          <WushTextField
            formRegistration={register("misc_tax_percent")}
            label="Misc Tax"
            defaultValue={item?.misc_tax_percent || organization.misc_tax_percent}
            inputStartAdornment={<InputAdornment position="start">%</InputAdornment>}
            sx={{ maxWidth: "100px" }}
          />
        </Stack>
        <Stack mb={2}>
          <WushYesNoField formRegistration={register("storefront_enabled")} label="Show on storefront" defaultValue={item?.storefront_enabled} />
        </Stack>
        <Stack>
          <Button disabled={!isDirty} variant="contained" type="submit">{item?.id ? "Update" : "Create"}</Button>
        </Stack>
      </form>
    </Stack>
  );
}